import React, { useState, useEffect } from "react";
import * as S from "./PlansStyle";
import { goldenVariableService } from "../../Services/goldenVariableService";
import ContasDeposito from "./ContasDeposito";
import {
  FaPlus,
  FaTrash,
  FaSave,
  FaExclamationTriangle,
  FaEdit,
  FaSpinner,
} from "react-icons/fa";

export default function Plans() {
  const [activeTab, setActiveTab] = useState("variaveis");
  const [loading, setLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdatingName, setIsUpdatingName] = useState(false);
  const [tempPromoName, setTempPromoName] = useState("");
  const [variables, setVariables] = useState({
    contractDuration: 36,
    contractMaxValorization: 150,
    contractUniPrice: 425,
    promoctionActivedName: "",
    contractPlans: [],
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const data = await goldenVariableService.getVariables();
      if (data) {
        setVariables({
          ...data,
          contractPlans: data.contractPlans || [],
        });
      }
    } catch (err) {
      console.error("Erro ao carregar configurações:", err);
      alert("Não foi possível carregar as configurações do sistema.");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = () => {
    setTempPromoName(variables.promoctionActivedName || "");
    setIsModalOpen(true);
  };

  const handleUpdatePromotionName = async () => {
    if (!tempPromoName.trim()) {
      alert("O nome da promoção não pode ser vazio.");
      return;
    }

    setIsUpdatingName(true);
    try {
      await goldenVariableService.updatePromotionName(tempPromoName);
      setVariables({ ...variables, promoctionActivedName: tempPromoName });
      setIsModalOpen(false);
    } catch (err) {
      alert("Erro ao atualizar nome: " + (err.response?.data || err.message));
    } finally {
      setIsUpdatingName(false);
    }
  };

  const handleAddPlan = () => {
    setVariables({
      ...variables,
      contractPlans: [
        ...variables.contractPlans,
        { min_qtt: 0, percentage: 0 },
      ],
    });
  };

  const handleRemovePlan = (index) => {
    const newPlans = [...variables.contractPlans];
    newPlans.splice(index, 1);
    setVariables({ ...variables, contractPlans: newPlans });
  };

  const handlePlanChange = (index, field, value) => {
    const newPlans = [...variables.contractPlans];
    const numericValue = value === "" ? 0 : parseFloat(value);
    newPlans[index][field] = numericValue;
    setVariables({ ...variables, contractPlans: newPlans });
  };

  const handleGlobalChange = (field, value) => {
    const numericValue = value === "" ? 0 : parseFloat(value);
    setVariables({ ...variables, [field]: numericValue });
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      const payload = {
        ...variables,
        contractPlans: [...variables.contractPlans].sort(
          (a, b) => a.min_qtt - b.min_qtt
        ),
      };
      await goldenVariableService.saveVariables(payload);
      alert("Configurações salvas com sucesso!");
      fetchData();
    } catch (err) {
      alert("Erro ao salvar: " + (err.response?.data || err.message));
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <S.Container>
      <S.Header>
        <h1>Configurações do Sistema</h1>
        {activeTab === "variaveis" && (
          <S.SaveButton onClick={handleSave} disabled={isSaving}>
            {isSaving ? (
              <S.SpinnerIcon>
                <FaSpinner />
              </S.SpinnerIcon>
            ) : (
              <>
                <FaSave /> Salvar Alterações
              </>
            )}
          </S.SaveButton>
        )}
      </S.Header>

      <S.TabBar>
        <S.TabButton
          $active={activeTab === "variaveis"}
          onClick={() => setActiveTab("variaveis")}
        >
          Variáveis do Sistema
        </S.TabButton>
        <S.TabButton
          $active={activeTab === "contas"}
          onClick={() => setActiveTab("contas")}
        >
          Contas de Depósito
        </S.TabButton>
      </S.TabBar>

      {activeTab === "contas" ? (
        <ContasDeposito />
      ) : loading ? (
        <p
          style={{
            color: "#B17D2A",
            fontSize: "1.2rem",
            textAlign: "center",
            marginTop: "100px",
          }}
        >
          Carregando configurações do sistema...
        </p>
      ) : (
        <>
      <S.Card
        style={{
          borderLeft: "6px solid #B17D2A",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <label
            style={{
              color: "#aaa",
              fontSize: "0.75rem",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            Campanha Ativa
          </label>
          <h2
            style={{ margin: "5px 0 0 0", color: "#fff", fontSize: "1.8rem" }}
          >
            {variables.promoctionActivedName || "Sem Nome Definido"}
          </h2>
        </div>
        <S.EditIconButton onClick={handleOpenModal}>
          <FaEdit size={22} />
        </S.EditIconButton>
      </S.Card>

      {isModalOpen && (
        <S.ModalOverlay
          onClick={() => !isUpdatingName && setIsModalOpen(false)}
        >
          <S.ModalContent onClick={(e) => e.stopPropagation()}>
            <h2>Editar Promoção</h2>
            <p>
              Defina o nome da campanha que aparecerá nos novos contratos
              gerados.
            </p>

            <S.FormGroup>
              <label>Nome da Promoção</label>
              <input
                type="text"
                value={tempPromoName}
                onChange={(e) => setTempPromoName(e.target.value)}
                placeholder="Ex: Black Friday 2024"
                autoFocus
              />
            </S.FormGroup>

            <S.ModalFooter>
              <S.AddButton
                onClick={() => setIsModalOpen(false)}
                disabled={isUpdatingName}
                style={{ border: "none" }}
              >
                Cancelar
              </S.AddButton>
              <S.SaveButton
                onClick={handleUpdatePromotionName}
                disabled={isUpdatingName || !tempPromoName.trim()}
              >
                {isUpdatingName ? (
                  <S.SpinnerIcon>
                    <FaSpinner />
                  </S.SpinnerIcon>
                ) : (
                  "Salvar Nome"
                )}
              </S.SaveButton>
            </S.ModalFooter>
          </S.ModalContent>
        </S.ModalOverlay>
      )}

      <S.Card>
        <h3>Configurações Globais</h3>
        <S.FormGrid>
          <S.FormGroup>
            <label>Preço Unitário (R$)</label>
            <input
              type="number"
              value={variables.contractUniPrice}
              onChange={(e) =>
                handleGlobalChange("contractUniPrice", e.target.value)
              }
            />
          </S.FormGroup>
          <S.FormGroup>
            <label>Duração (Meses)</label>
            <input
              type="number"
              value={variables.contractDuration}
              onChange={(e) =>
                handleGlobalChange("contractDuration", e.target.value)
              }
            />
          </S.FormGroup>
          <S.FormGroup>
            <label>Teto Valorização (%)</label>
            <input
              type="number"
              value={variables.contractMaxValorization}
              onChange={(e) =>
                handleGlobalChange("contractMaxValorization", e.target.value)
              }
            />
          </S.FormGroup>
        </S.FormGrid>
      </S.Card>

      <S.Card>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <div>
            <h3>Régua de Valorização</h3>
            <p
              style={{
                color: "#888",
                fontSize: "0.85rem",
                margin: "5px 0 0 15px",
              }}
            >
              Configuração de rendimento mensal por quantidade de cotas.
            </p>
          </div>
          <S.AddButton onClick={handleAddPlan}>
            <FaPlus /> Nova Faixa
          </S.AddButton>
        </div>

        {variables.contractPlans.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              padding: "40px",
              background: "rgba(0,0,0,0.1)",
              borderRadius: "8px",
            }}
          >
            <FaExclamationTriangle
              size={30}
              color="#B17D2A"
              style={{ marginBottom: "10px" }}
            />
            <p style={{ color: "#666" }}>Nenhuma faixa configurada.</p>
          </div>
        ) : (
          <S.Table>
            <thead>
              <tr>
                <th>Qtd Mínima</th>
                <th>Valorização Mensal (%)</th>
                <th style={{ textAlign: "center" }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {variables.contractPlans.map((plan, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="number"
                      value={plan.min_qtt}
                      onChange={(e) =>
                        handlePlanChange(index, "min_qtt", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      step="0.01"
                      value={plan.percentage}
                      onChange={(e) =>
                        handlePlanChange(index, "percentage", e.target.value)
                      }
                    />
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <S.DeleteButton onClick={() => handleRemovePlan(index)}>
                      <FaTrash />
                    </S.DeleteButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </S.Table>
        )}
      </S.Card>
        </>
      )}
    </S.Container>
  );
}
